const enableds = {
    showReportsInMainMenu: true,
}

export default enableds;